import { Col, Row, Spin } from 'antd'
import LineItemMap from 'app/components/Core/LineItem/Map'
import PageWrapper from 'app/components/UI-Elements/Layout/PageWrapper'
import { normalizeLineItem } from 'app/lib/apollo/normalizers/LineItem'
import { normalizeAddressSummary } from 'app/lib/apollo/normalizers/Rental'
import { useQuery } from 'app/lib/hooks/useQuery'
import * as projects from 'app/queries/Projects'
import * as React from 'react'
import { useParams } from 'react-router-dom'

const Map: React.FC = () => {
  const { project_id } = useParams<{ project_id: string }>()

  const {
    data: { project },
    loading
  } = useQuery<{ project: IProject }>(projects.FETCH_PROJECT_PRODUCTS, {
    fetchPolicy: 'network-only',
    variables: {
      id: project_id
    },
    normalizer: (data) => ({
      ...data,
      project: {
        ...data.project,
        products: data.project.products.map((product) => ({
          ...normalizeLineItem(product),
          location: normalizeAddressSummary(data.project.address)
        }))
      }
    })
  })

  return (
    <PageWrapper transparent={false}>
      <Row gutter={[0, 24]}>
        <Col span={24}>
          <Spin spinning={loading}>
            <LineItemMap collection={project?.products || []} />
          </Spin>
        </Col>
      </Row>
    </PageWrapper>
  )
}

export default Map
